import gql from 'graphql-tag'


export const GET_CURRENT_USER = gql `
  query current_user {
    currentUser {
      name
    }

    permissions {
        id
        name
    }
  }
`

export const GET_ASSESSMENT_LIST = gql `
  query assessments($courseId: ID) {
    assessments(courseId: $courseId) {
        id
        title
        scores {
          id
          value
          student {
            id
            name
            email
          }
        }
        allStudentScores {
          id
          name
          email
          value
        }
        unscoredStudents {
          id
          name
          email
        }
        course {
          id
          name
          classroom {
            id
            name
          }
        }
    }
  }
`

export const GET_COURSE_LIST = gql `
  query courses {
    courses {
      id
      name
      classroom {
        id
        name
      }
    }
  }
`

export const GET_CLASSROOM_LIST = gql `
  query classrooms {
    classrooms {
      id
      students {
          id
      }
    }
  }
`

export const GET_ATTENDANCE_LIST = gql `
  query classroomAttendances($search: String, $startDate: String, $endDate: String, $classroomId: ID, $statusId: ID) {
    classroomAttendances(search: $search, startDate: $startDate, endDate: $endDate, classroomId: $classroomId, statusId: $statusId) {
      id
      date

      classroom {
        id
        name
      }

      studentAttendances {
        id
        createdAt
        student {
            id
            name
            classroom {
                id
                name
            }
        }

        status {
            id
            name
        }
      }
    }
}
`

export const GET_GROUPED_ATTENDANCE_LIST = gql `
  query groupedClassroomAttendances {
    groupedClassroomAttendances {
      id
      date

      classrooms {
        id
        name
      }

      studentAttendances {
        id
        createdAt
        student {
            id
            name
            classroom {
                id
                name
            }
        }

        status {
            id
            name
        }
      }
    }
}
`

export const GET_TODAY_ATTENDANCE_LIST = gql `
  {
    todayClassroomAttendances {
        id
        date

        classroom {
          id
          name
        }

        studentAttendances {
            id
            createdAt
            student {
                id
                name
                classroom {
                    name
                }
            }

            status {
                id
                name
            }
        }
    }
  }
`

export const QUERY_GET_SELECTED_RETURN_FILTERS_CLIENT = gql`
  {
    selectReturnFilters @client
  }
`

export const GET_DEPOSIT_LIST = gql `
  {
    depositTransactions {
        id
        createdAt
        amount
        account {
            id
            user {
                id
                name
                kind
            }
        }
        action {
            id
            name
        }
    }
  }
`

export const GET_TRANSACTION_LIST = gql `
query transactions($startDate: String, $endDate: String, $actionId: ID) {
  transactions(startDate: $startDate, endDate: $endDate, actionId: $actionId) {
        id
        createdAt
        amount
        account {
            id
            user {
                id
                name
                kind
                classroom {
                    name
                }
            }
        }
        action {
            id
            name
        }
        deviceId
        foodVendor {
          id
          name
          deviceId
          createdAt
          updatedAt
        }
    }
  }
`

export const GET_MENU_ORDER_LIST = gql `
query menuOrders($startDate: String, $endDate: String) {
  menuOrders(startDate: $startDate, endDate: $endDate) {
    id
    done
    createdAt
    userId
    user {
      id
      name
    }
    items {
      id
      menuId
      name
      price
      quantity
    }
    foodVendor {
        id
        deviceId
        name
        createdAt
    }
  }
}
`

export const GET_ACTIVITY_LIST = gql `
  {
    activities {
        id
        admin {
          name
          email
        }
        action
        createdAt
    }
  }
`

export const GET_USER_LIST = gql `
  {
    users {
        id
        name
        kind
        classroom {
          id
          name
          active
        }
    }
  }
`
export const GET_CASH_ACCOUNT_LIST = gql `
  {
    cashAccounts {
        id
        userId
        balance
        createdAt
        user {
            id
            name
            kind
            classroom {
                name
            }
            identifications {
              id
              kind
              value
            }
        }
    }
  }
`

export const GET_ROOM_LIST = gql `
  {
    rooms {
        group {
            id
            name
        }
        roomNumber
        totalBeds
        currentReservations {
            student {
                id
                name
                classroom {
                    name
                }
                boardingMasterMentor {
                    teacher {
                        id
                        name
                    }
                }
            }
            status {
                id
                name
            }
        }
        boardingMaster {
            id
            name
        }
        color
    }
  }
`
// export const GET_PROFILE_LIST = gql`
//   query profiles {
// 	  profiles {
//       id
//       name
//       email
//       totalAccounts
//       company {
//         id
//         name
//       }
//       type {
//         id
//         name 
//       }
//       status {
//         id
//         status
//       }
// 	  }
//   }
// `
// export const GET_TYPE_LIST = gql`
//   query profileTypes {
//     profileTypes {
//       id
//       name
//     }
//   }
// `
// export const GET_STATUS_LIST = gql`
//   query profileStatuses {
//     profileStatuses {
//       id
//       status
//     }
//   }
// `
// export const GET_COMPANY_LIST = gql`
//   query companies($search: String, $limit: Int) {
//     companies (search: $search, limit: $limit){
//       id
//       name
//     }
//   }
// `

// export const MUTATION_CREATE_COMPANY = gql`
//   mutation createCompany($input: CreateCompanyInput!) {
//     createCompany (input: $input) {
//       company {
//         id
//       }
//     }
//   }
// `

// export const MUTATION_UPDATE_PROFILE = gql`
//   mutation updateProfile($input: UpdateProfileInput!) {
//     updateProfile (input: $input) {
//       profile {
//         id
//         name
//       }
//     }
//   }
// `